import {actions} from './actions';
import {getters} from './getters';
import {mutations} from './mutations';
import {state} from './state';

// Export reservation store
export const feedback = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
